import PropTypes from 'prop-types'
import React from 'react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import content from 'pp-react-l10n'
let i18n = content('transfer/preferredLegalScroll')

const styles = StyleSheet.create({
  wrapper: {
    padding: '0 20px',
  },
  cancelButton: {
    margin: '40px auto 0',
    display: 'block',
    width: 200,
  },
})

class PreferredLegalScroll extends React.Component {
  static propTypes = {
    handleCloseButton: PropTypes.func.isRequired,
    userAgreementLinkUrl: PropTypes.string.isRequired,
    isPSAEnabled: PropTypes.bool.isRequired,
  }

  render() {
    return (
      <div className={css(styles.wrapper)}>
        <h2>{i18n('header')}</h2>
        <h5>{i18n('subHeader')}</h5>
        <h4>{i18n('willLi.header')}</h4>
        <ul>
          <li>{i18n('willLi.shopOnline')}</li>
          <li>{i18n('willLi.goodsAndServices')}</li>
        </ul>
        <h4>{i18n('wontLi.header')}</h4>
        <ul>
          <li>{i18n('wontLi.shopStore')}</li>
          {!this.props.isPSAEnabled ? (
            <li>{i18n('wontLi.friendsAndFamily')}</li>
          ) : null}
          <li>{i18n('wontLi.preapproved')}</li>
        </ul>
        <p>
          {i18n('main', {
            userAgreementLinkUrl: (
              <a href={this.props.userAgreementLinkUrl} target="_blank">
                {i18n('legal.userAgreement')}
              </a>
            ),
          })}
        </p>
        <button
          className={`${css(styles.cancelButton)} vx_btn`}
          onClick={this.props.handleCloseButton}
        >
          {i18n('button.close')}
        </button>
      </div>
    )
  }
}

export default PreferredLegalScroll
